/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="95.5"
        viewBox="0 0 95.58 95.5"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <defs>
          <mask
            id="ef6ba499-d3ce-4598-9866-2180c5b5efb3"
            x="23.13"
            y="0.99"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M666.27,347.12v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="f8bb5f33-5370-41e8-8285-6a23dd9ff10f"
            x="16.96"
            y="0.99"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M660.1,347.12v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="fb0d1cbb-dc62-4760-85da-efc29cfb8ab6"
            x="10.66"
            y="0.99"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M653.81,347.12v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.25-1.25h0v-2.5a1.34,1.34,0,0,0-1.25-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="a444be32-1791-4a8a-a459-7da6cedef1c3"
            x="23.13"
            y="11.37"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M666.27,357.5V360a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.18,1.18,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="bfb32f33-f82d-4cec-94e3-36008604bb09"
            x="16.96"
            y="11.37"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M660.1,357.5V360a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b039373d-87d1-4861-a265-f8ad2433ea04"
            x="10.66"
            y="11.37"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M653.81,357.5V360a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.25-1.25h0v-2.5a1.25,1.25,0,0,0-1.25-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="fff8bc02-7f0e-4b90-9f44-35706b54c5db"
            x="16.96"
            y="21.62"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M660.1,367.75v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="be4a6d04-a76e-48b9-9067-d58aa91c4b93"
            x="10.66"
            y="21.62"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M653.81,367.75v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.25-1.25h0v-2.5a1.25,1.25,0,0,0-1.25-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="fb23c16e-66c1-4314-9920-4b08b9184ed5"
            x="16.96"
            y="31.87"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M660.1,378v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0V378a1.35,1.35,0,0,0-1.26-1.25h0A1.19,1.19,0,0,0,660.1,378Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="aca598b9-fbfc-422a-b910-a88e7f00e4c1"
            x="10.66"
            y="31.87"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M653.81,378v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.25-1.25h0V378a1.34,1.34,0,0,0-1.25-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ac03a573-a757-4458-9ad2-a2ffda32ed64"
            x="16.96"
            y="42.25"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M660.1,388.38v2.5a1.19,1.19,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.19,1.19,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="bc936e4c-e994-4443-8965-0fd57a54a663"
            x="10.66"
            y="42.25"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M653.81,388.38v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.25-1.25h0v-2.5a1.25,1.25,0,0,0-1.25-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ae8f01f7-bac7-4c52-93b0-83f73a4ca2e5"
            x="45.04"
            y="30.46"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M688.19,376.59v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="e8e0b07d-6312-4cbe-b7be-1eea27d5aaf0"
            x="38.87"
            y="30.46"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M682,376.59v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="edfad82d-5c31-4732-9425-a30ed4b482e5"
            x="32.57"
            y="30.46"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M675.72,376.59v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b51de739-2c2b-494f-af54-bace40e48cfa"
            x="45.04"
            y="40.84"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M688.19,387v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0V387a1.19,1.19,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b70ece10-6cfd-4cb6-a41e-ad8f6813d22a"
            x="38.87"
            y="40.84"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M682,387v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0V387a1.26,1.26,0,0,0-1.26-1.25h0A1.18,1.18,0,0,0,682,387Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ebc6959f-0c6f-4b0d-8243-1f595fd2d9b5"
            x="32.57"
            y="40.84"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M675.72,387v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0V387a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="aca09944-3416-4474-8c5b-ee45e98a1957"
            x="45.04"
            y="51.09"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M688.19,397.22v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.19,1.19,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ae2ebda2-3964-44a9-b4a0-4859bdcea4ec"
            x="38.87"
            y="51.09"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M682,397.22v2.5a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="e4581cd1-adb0-4046-af06-4d21f872d9d5"
            x="32.57"
            y="51.09"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M675.72,397.22v2.5A1.18,1.18,0,0,0,677,401h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5A1.26,1.26,0,0,0,677,396h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="ac8b0b21-9d56-4bdf-99b6-c766ba96b711"
            x="45.04"
            y="61.34"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M688.19,407.47V410a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="fc642f7e-bbea-4c3b-a29c-072eb9bcbc49"
            x="38.87"
            y="61.34"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M682,407.47V410a1.18,1.18,0,0,0,1.26,1.25h0a1.19,1.19,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="e7da0a42-faef-44cb-803f-10f7f78d3313"
            x="32.57"
            y="61.34"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M675.72,407.47V410a1.18,1.18,0,0,0,1.26,1.25h0a1.18,1.18,0,0,0,1.26-1.25h0v-2.5a1.35,1.35,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="b8af2c6a-7d4b-4c51-9be5-1c72c2bb8a7e"
            x="45.04"
            y="71.71"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M688.19,417.84v2.5a1.19,1.19,0,0,0,1.26,1.26h0a1.19,1.19,0,0,0,1.26-1.26h0v-2.5a1.19,1.19,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="f678b483-94e2-426f-942f-66fcf52e07aa"
            x="38.87"
            y="71.71"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M682,417.84v2.5a1.19,1.19,0,0,0,1.26,1.26h0a1.19,1.19,0,0,0,1.26-1.26h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
          <mask
            id="f617d784-5122-4989-ba55-cf8dbafa465a"
            x="32.57"
            y="71.71"
            width="18.78"
            height="21.26"
            maskUnits="userSpaceOnUse">
            <g transform="translate(-635.02 -336.75)">
              <path
                d="M675.72,417.84v2.5A1.19,1.19,0,0,0,677,421.6h0a1.19,1.19,0,0,0,1.26-1.26h0v-2.5a1.26,1.26,0,0,0-1.26-1.25h0a1.18,1.18,0,0,0-1.26,1.25Z"
                fill="#fff"
                className="icon-fill icon-base"
                fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <path
          d="M675.15,336.75a1.26,1.26,0,0,1,1.25,1.12v28a1.25,1.25,0,0,1-2.49.13V339.25H648.7v59.5h19.16a1.24,1.24,0,0,1,1.24,1.12V400a1.24,1.24,0,0,1-1.12,1.24H647.45a1.26,1.26,0,0,1-1.25-1.12V338a1.26,1.26,0,0,1,1.12-1.25h27.83Z"
          transform="translate(-635.02 -336.75)"
          fill="#fff"
          className="icon-fill icon-base"/><path
          d="M667.53,345.87a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#ef6ba499-d3ce-4598-9866-2180c5b5efb3)' }}>
          <polygon
            id="a37b89f0-f218-46ec-9f34-4359837cbcda"
            data-name="Fill-4"
            points="23.13 22.26 41.91 22.26 41.91 0.99 23.13 0.99 23.13 22.26"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M661.36,345.87a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#f8bb5f33-5370-41e8-8285-6a23dd9ff10f)' }}>
          <polygon
            points="16.95 22.26 35.74 22.26 35.74 0.99 16.95 0.99 16.95 22.26"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M655.07,345.87a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.34,1.34,0,0,0-1.25-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#fb0d1cbb-dc62-4760-85da-efc29cfb8ab6)' }}>
          <polygon
            points="10.66 22.26 29.44 22.26 29.44 0.99 10.66 0.99 10.66 22.26"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M667.53,356.25a1.19,1.19,0,0,0-1.26,1.25V360a1.26,1.26,0,0,0,2.52,0v-2.5a1.18,1.18,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#a444be32-1791-4a8a-a459-7da6cedef1c3)' }}>
          <polygon
            points="23.13 32.63 41.91 32.63 41.91 11.37 23.13 11.37 23.13 32.63"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M661.36,356.25a1.19,1.19,0,0,0-1.26,1.25V360a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#bfb32f33-f82d-4cec-94e3-36008604bb09)' }}>
          <polygon
            points="16.95 32.63 35.74 32.63 35.74 11.37 16.95 11.37 16.95 32.63"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M655.07,356.25a1.18,1.18,0,0,0-1.26,1.25V360a1.26,1.26,0,0,0,2.51,0v-2.5a1.25,1.25,0,0,0-1.25-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#b039373d-87d1-4861-a265-f8ad2433ea04)' }}>
          <polygon
            points="10.66 32.63 29.44 32.63 29.44 11.37 10.66 11.37 10.66 32.63"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M661.36,366.5a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#fff8bc02-7f0e-4b90-9f44-35706b54c5db)' }}>
          <polygon
            points="16.95 42.88 35.74 42.88 35.74 21.62 16.95 21.62 16.95 42.88"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M655.07,366.5a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.25,1.25,0,0,0-1.25-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#be4a6d04-a76e-48b9-9067-d58aa91c4b93)' }}>
          <polygon
            points="10.66 42.88 29.44 42.88 29.44 21.62 10.66 21.62 10.66 42.88"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M661.36,376.75A1.19,1.19,0,0,0,660.1,378v2.5a1.26,1.26,0,0,0,2.52,0V378a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#fb23c16e-66c1-4314-9920-4b08b9184ed5)' }}>
          <polygon
            points="16.95 53.13 35.74 53.13 35.74 31.87 16.95 31.87 16.95 53.13"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          id="bb32968a-a916-462f-a5e9-272d685f4bce"
          data-name="Fill-47"
          d="M655.07,376.75a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.51,0V378a1.34,1.34,0,0,0-1.25-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#aca598b9-fbfc-422a-b910-a88e7f00e4c1)' }}>
          <polygon
            points="10.66 53.13 29.44 53.13 29.44 31.87 10.66 31.87 10.66 53.13"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M661.36,387.13a1.19,1.19,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#ac03a573-a757-4458-9ad2-a2ffda32ed64)' }}>
          <polygon
            points="16.95 63.51 35.74 63.51 35.74 42.24 16.95 42.24 16.95 63.51"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M655.07,387.13a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.51,0v-2.5a1.25,1.25,0,0,0-1.25-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#bc936e4c-e994-4443-8965-0fd57a54a663)' }}>
          <polygon
            points="10.66 63.51 29.44 63.51 29.44 42.24 10.66 42.24 10.66 63.51"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><g>
          <path
            d="M729.35,429.75a1.25,1.25,0,0,1,.13,2.5H636.27a1.25,1.25,0,0,1-.13-2.49h93.21Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M723.66,394.75a1.25,1.25,0,0,1,.13,2.49H697.48a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M716,342.62a1.25,1.25,0,0,1,1.24,1.13v43.5a1.25,1.25,0,0,1-2.49.13V345.12H691.31v13.57a1.26,1.26,0,0,1-1.13,1.24h-.12a1.26,1.26,0,0,1-1.25-1.12V343.87a1.25,1.25,0,0,1,1.12-1.24H716Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M669,398.75a1.25,1.25,0,0,1,.13,2.49h-26V430.9a1.26,1.26,0,0,1-1.12,1.25h-.13A1.25,1.25,0,0,1,640.7,431V400a1.25,1.25,0,0,1,1.13-1.24H669Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M696.81,353.76a1.25,1.25,0,0,1,1.82,1V430.9a1.25,1.25,0,0,1-2.49.13v-74.1l-25.72,13.41-.11.06v60.5a1.26,1.26,0,0,1-1.13,1.25h-.12A1.26,1.26,0,0,1,667.8,431V369.67a1.27,1.27,0,0,1,.53-1l.11-.07.78-.43Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M655.49,412.39a7.71,7.71,0,0,1,7.7,7.46v11a1.25,1.25,0,0,1-2.49.13V420.09a5.2,5.2,0,0,0-10.4-.22v11a1.25,1.25,0,0,1-2.49.13V420.09A7.7,7.7,0,0,1,655.49,412.39Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M689.45,375.34a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
            transform="translate(-635.02 -336.75)"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><g style={{ mask: 'url(#ae8f01f7-bac7-4c52-93b0-83f73a4ca2e5)' }}>
          <polygon
            points="45.04 51.73 63.82 51.73 63.82 30.46 45.04 30.46 45.04 51.73"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M683.28,375.34a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#e8e0b07d-6312-4cbe-b7be-1eea27d5aaf0)' }}>
          <polygon
            points="38.87 51.73 57.65 51.73 57.65 30.46 38.87 30.46 38.87 51.73"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M677,375.34a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#edfad82d-5c31-4732-9425-a30ed4b482e5)' }}>
          <polygon
            points="32.57 51.73 51.35 51.73 51.35 30.46 32.57 30.46 32.57 51.73"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M689.45,385.72a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0V387a1.19,1.19,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#b51de739-2c2b-494f-af54-bace40e48cfa)' }}>
          <polygon
            points="45.04 62.1 63.82 62.1 63.82 40.84 45.04 40.84 45.04 62.1"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M683.28,385.72A1.18,1.18,0,0,0,682,387v2.5a1.26,1.26,0,0,0,2.52,0V387a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#b70ece10-6cfd-4cb6-a41e-ad8f6813d22a)' }}>
          <polygon
            points="38.87 62.1 57.65 62.1 57.65 40.84 38.87 40.84 38.87 62.1"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M677,385.72a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0V387a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#ebc6959f-0c6f-4b0d-8243-1f595fd2d9b5)' }}>
          <polygon
            points="32.57 62.1 51.35 62.1 51.35 40.84 32.57 40.84 32.57 62.1"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M689.45,396a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.19,1.19,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#aca09944-3416-4474-8c5b-ee45e98a1957)' }}>
          <polygon
            points="45.04 72.35 63.82 72.35 63.82 51.09 45.04 51.09 45.04 72.35"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M683.28,396a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#ae2ebda2-3964-44a9-b4a0-4859bdcea4ec)' }}>
          <polygon
            points="38.87 72.35 57.65 72.35 57.65 51.09 38.87 51.09 38.87 72.35"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M677,396a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5A1.26,1.26,0,0,0,677,396"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#e4581cd1-adb0-4046-af06-4d21f872d9d5)' }}>
          <polygon
            points="32.57 72.35 51.35 72.35 51.35 51.09 32.57 51.09 32.57 72.35"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M689.45,406.22a1.18,1.18,0,0,0-1.26,1.25V410a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#ac8b0b21-9d56-4bdf-99b6-c766ba96b711)' }}>
          <polygon
            points="45.04 82.6 63.82 82.6 63.82 61.34 45.04 61.34 45.04 82.6"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M683.28,406.22a1.18,1.18,0,0,0-1.26,1.25V410a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#fc642f7e-bbea-4c3b-a29c-072eb9bcbc49)' }}>
          <polygon
            points="38.87 82.6 57.65 82.6 57.65 61.34 38.87 61.34 38.87 82.6"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M677,406.22a1.18,1.18,0,0,0-1.26,1.25V410a1.26,1.26,0,0,0,2.52,0v-2.5a1.35,1.35,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#e7da0a42-faef-44cb-803f-10f7f78d3313)' }}>
          <polygon
            points="32.57 82.6 51.35 82.6 51.35 61.34 32.57 61.34 32.57 82.6"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M689.45,416.59a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.19,1.19,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#b8af2c6a-7d4b-4c51-9be5-1c72c2bb8a7e)' }}>
          <polygon
            points="45.04 92.98 63.82 92.98 63.82 71.71 45.04 71.71 45.04 92.98"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M683.28,416.59a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#f678b483-94e2-426f-942f-66fcf52e07aa)' }}>
          <polygon
            points="38.87 92.98 57.65 92.98 57.65 71.71 38.87 71.71 38.87 92.98"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><path
          d="M677,416.59a1.18,1.18,0,0,0-1.26,1.25v2.5a1.26,1.26,0,0,0,2.52,0v-2.5a1.26,1.26,0,0,0-1.26-1.25"
          transform="translate(-635.02 -336.75)"
          fill="#ffb81c"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><g style={{ mask: 'url(#f617d784-5122-4989-ba55-cf8dbafa465a)' }}>
          <polygon
            points="32.57 92.98 51.35 92.98 51.35 71.71 32.57 71.71 32.57 92.98"
            fill="#ffb81c"
            className="icon-fill icon-accent"
            fillRule="evenodd"/>
        </g><g>
          <path
            d="M723.67,386a1.26,1.26,0,0,1,1.25,1.12v43.8a1.25,1.25,0,0,1-2.49.13V388.5H697.48a1.26,1.26,0,0,1-1.25-1.12v-.13a1.24,1.24,0,0,1,1.12-1.24h26.32Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M723.66,403.5a1.25,1.25,0,0,1,.13,2.49H697.48a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M723.66,412.25a1.25,1.25,0,0,1,.13,2.5H697.48a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
          <path
            d="M723.66,421a1.25,1.25,0,0,1,.13,2.5H697.48a1.25,1.25,0,0,1-.13-2.49h26.31Z"
            transform="translate(-635.02 -336.75)"
            fill="#fff"
            className="icon-fill icon-base"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CityscapeIcon';

export default Icon;
